import React, { useState, useRef } from 'react';
import styles from './Comment.module.scss';
import { Button,FormGroup, Input } from 'reactstrap';
import { useParams } from 'react-router-dom';
import useApiPrivate from '../../../utils/hooks/useApiPrivate';
import useAuth from '../../../utils/hooks/useAuth';
import { Toast } from 'primereact/toast';

const COMMENT_URL = 'api/v1/comments';

export default function Comment({comment, productOwnerId, onCallProductComment}) {
    const { auth } = useAuth();
    const [replyComment, setReplyComment] =useState("");
    const [showReplyBox, setShowReplyBox] = useState(false);

    const inputEl= useRef(null);
    const { id } = useParams();
    const apiPrivate = useApiPrivate();
    const toast = useRef(null);

    const showSuccess = (message) => {
        toast.current.show({severity:'success', summary: 'Success', detail: message, life: 3000});
    }
    const showError = (message) => {
        toast.current.show({severity:'error', summary: 'Error', detail: message, life: 3000});
    }

    const showInfo = () => {
        toast.current.show({severity:'info', summary: 'Info', detail:'Message Content', life: 3000});
    }

    const addReply = async(id, commentId, replyComment) => {
        try{
            const response = await apiPrivate.post(COMMENT_URL, JSON.stringify({product_id: id, pid: commentId, comment: replyComment}));
            if(response?.status === 208) {
                showInfo(response?.data?.message)
                return
            }
            setShowReplyBox(false);
            setReplyComment('');
            showSuccess('Your comment has been registered successfully')
            setTimeout(() => {
                onCallProductComment();
            },3000)
        }
        catch (error){
            showError('Your comment encountered an error')
        }
    }

  return (
    <>
        <Toast ref={toast} position="top-center" />

        <div key={comment.id} className={`${styles.commentBox} px-3 py-2 mb-4 level-1 ${!comment.is_verify && styles.noVerify}`}>
        <div className={`${styles.commentInfo} mb-2`}>
            <div>
                {
                    comment.user.avatar 
                        ? <img src={`${process.env.REACT_APP_API_URL}${comment.user.avatar}`} alt='Profile Image' className={`img-fluid me-3 ${styles.profileImage}`}/>
                        : <i className={`bi bi-person me-3 ${styles.userIcon}`}></i>
                }
                <a 
                    href='#' 
                    className={`${styles.username} fw-bold text-decoration-none`} 
                    disabled={!comment.is_verify && true}
                >
                    {comment.user.username}
                </a>
                <span className={`fw-bold ${styles.date} ms-3`}>
                    {
                        (comment.created_at).slice(0,10)
                    }
                </span>
            </div>
            {
               !showReplyBox &&(
                    auth &&
                        productOwnerId == auth?.userInfo?.user?.id &&
                            <Button
                                className={`${styles.replyBtn} fw-bolder text-decoration-none`}
                                disabled={comment.reply || !comment.is_verify && true}
                                onClick={() => {
                                    setShowReplyBox(true);
                                    setTimeout(() => inputEl.current.focus());
                                }}
                            >
                                {
                                    comment.is_verify ? <i className="bi bi-reply"></i> : ''
                                }
                                
                                {
                                comment.is_verify ? 'Reply' : 'ٔNot confirmed'
                                }
                            </Button>
                )
            }
        </div>
        <div>
            {comment.comment}
        </div>
       
    </div>
    { showReplyBox && (

        <FormGroup className={`ms-4`}>
            <Input 
                type={'textarea'} 
                ref={inputEl}
                value={replyComment}
                className={`${styles.askQuestion} mb-2`} 
                placeholder="Answer the question"
                onChange={(e) => {setReplyComment(e.target.value)}}
            >
            </Input>
            <Button 
                className={`px-4 me-2`}
                disabled={replyComment.length < 10}
                onClick={() => {
                    addReply(id, comment.id, replyComment);
                }}
            >
                Send
            </Button>
            <Button 
                className={`px-4`}
                onClick={() => {
                    setShowReplyBox(false);
                    setReplyComment("");
                  }}
            >
                cancel
            </Button>
        </FormGroup>        
    )
    }
    {
        comment.reply_comment && (
            comment.reply_comment.map((item) => (
                <div key={item.id}  className={`${styles.commentBox} ${styles.level2} px-3 py-2 mb-4 ms-2 ms-sm-4 ${!item.is_verify && styles.noVerify}`}>
                    <div className={`${styles.commentInfo} mb-2`}>
                        <div>
                            <a href='#' className={`${styles.username} fw-bold text-decoration-none`} disabled={!comment.is_verify && true}>
                                {item.user.username}
                            </a>
                            <span className={`fw-bold ${styles.date} ms-3`}>
                                {(comment.created_at).slice(0,10)}
                            </span>
                        </div>
                    </div>
                    <div className={`${styles.commentContent}`}>
                        {item.comment}
                    </div>
                </div>

            ))
            )
    }
    </>
  )
}
